// extracted by mini-css-extract-plugin
export default {"UserContent":"ChatBubble_UserContent__FtRVn"};